import React from 'react'
import { withNavigation } from '../templates/navigation/withNavigation'
import GeneralInfoLayout from '../templates/general-info/GeneralInfoLayout'
import GeneralInfoForm from '../templates/general-info/GeneralInfoForm'
import GeneralInfoFormContact from '../templates/general-info/GeneralInfoFormContact';
import GeneralInfoFormLocationContainer from '../templates/general-info/GeneralInfoFormLocationContainer';


const GeneralInfoPage = () => (
  <GeneralInfoLayout
    renderGeneralInfoForm={<GeneralInfoForm />}
    renderGeneralInfoFormContact={<GeneralInfoFormContact />}
    renderGeneralInfoFormLocation={<GeneralInfoFormLocationContainer />}
  />
)

export default withNavigation({ title: 'General Info' })(GeneralInfoPage)



// WEBPACK FOOTER //
// ./src/components/pages/GeneralInfoPage.js